export enum DeviceSize {
  MIN_WIDTH = 'minwidth',
  APP_MIN_WIDTH = 'app-minwidth',
  XXS = 'xxs',
  XS = 'xs',
  S = 's',
  M = 'm',
  BOARD_TABS_MOBILE_BREAKPOINT = 'board-tabs-mobile-breakpoint',
  L = 'l',
  Xl = 'xl',
  APP_MAX_WIDTH = 'app-maxwidth',
  MAX_WIDTH = 'maxwidth',
}
